export default {
    appTitle: 'Web de prestadores',
    title: 'Iniciar sessão',
    loginButton: 'Iniciar sessão',
    forgotPasswordButton: 'Esqueceu a senha',
    signIn: {
        button: 'Criar uma conta',
        label: 'Você ainda não tem uma conta?',
    },
    email: {
        inputLabel: 'Email',
    },
    password: {
        inputLabel: 'Senha'
    }
}